

import { Component, Emit, Mixins, Prop } from "vue-property-decorator";
import IBTooltip from "@/components/IBTooltip/IBTooltip.vue";

import GlobalMixin from "@/mixins/global";
import { profileEntity } from "@/models/modules/profile/entity";
import { TranslateResult } from "vue-i18n";
import { Role } from "@/mixins/role/role";
import { IUpdateCompanyMfo, IUpdateCompanyUlName } from "@/api/mainPage/company/interface";
import DropdownNew from "@/components/Dropdown/New/DropdownNew.vue";
import DropdownItem from "@/components/Dropdown/New/DropdownItem.vue";

@Component({
	components: { DropdownItem, DropdownNew, IBTooltip }
})
export default class HeaderProfileDropdown extends Mixins(
	GlobalMixin,
	Role
) {

	@Prop({ type: Array, default: () => [] })
	readonly list!: IUpdateCompanyUlName[];

	@Prop({ type: Boolean, default: false })
	readonly isDropdown!: boolean;

	directorInfoLocal: string = 'roleInfo.director';
	accountantInfoLocal: string = 'roleInfo.accountant';
	employeeInfoLocal: string = 'roleInfo.employee';

	isDropdownOpen: boolean = false;

	getMfoUllByProfileData(arr: IUpdateCompanyUlName[] | undefined): IUpdateCompanyMfo | null {
		let mfoUl = null;

		arr && arr.forEach(i => {
			i.branches?.forEach(_i => {
				if (_i.mfoUl === profileEntity.profileData?.mfoUl) mfoUl = _i
			})
		})

		return mfoUl;
	}

	get getCurrentInfoByRole(): TranslateResult {
		return this.$t((this as any)[profileEntity.profileData?.role?.toLowerCase() + 'InfoLocal'])
	}

	get ulNameLocal(): string | undefined {
		return profileEntity.profileData?.ulName;
	}

	get mfoUlLocal(): string | undefined {
		return profileEntity.profileData?.mfoUl;
	}

	get profileRole(): string | TranslateResult {
		return this.getCurrentRoleLocal || '';
	}

	get mfoTitle(): string {
		const searchBranch = this.getMfoUllByProfileData(profileEntity.company?.employeeInfo || undefined);

		if (searchBranch) return searchBranch.mfoTitle;

		return '';
	}

	get inputMfo(): string | undefined {
		return profileEntity.profileData?.mfoUl;
	}

	get profileMfo(): string | undefined {
		return `${ this.inputMfo } ${ this.mfoTitle }`;
	}

	@Emit('change')
	dropdownChange(chip: IUpdateCompanyUlName, item: IUpdateCompanyMfo) {
		this.isDropdownOpen = !this.isDropdownOpen;

		return { chip, item };
	}
}
